import classNames from 'classnames';
import { FC } from 'react';
import styles from './Tabs.module.css';
import { TabsProps } from './Tabs.types';

const Tabs: FC<TabsProps> = ({ tabs, activeTab, onTabClick }) => (
  <div className={styles.container}>
    {tabs.map((tab, index) => (
      <button
        className={classNames(styles.tabButton, { [styles.isActive]: index === activeTab })}
        onClick={() => {
          onTabClick(index);
        }}
        key={tab.id}
        id={tab.id}
        data-index={index}
        type="button"
      >
        <span className={styles.tab}>
          <div className={styles.icon}> {tab.icon}</div>
          {tab.label}
        </span>
      </button>
    ))}
  </div>
);

export default Tabs;
